import { render, staticRenderFns } from "./PreloaderInitial.vue?vue&type=template&id=ae734062&lang=pug&"
import script from "./PreloaderInitial.vue?vue&type=script&lang=js&"
export * from "./PreloaderInitial.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderInitial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports